import { combineReducers } from 'redux'
import userReducer from './user.reducer.js'
import enterpriseReducer from './enterprise.reducer'
import notificationReducer from './notification.reducer'
import siteApplicationReducer from './siteapplication.reducer.js'

export default combineReducers({
  self: userReducer,
  siteApplication: siteApplicationReducer,
  notification: notificationReducer,
  enterprise: enterpriseReducer
})
